/**
 * usePendingReviewCount — Badge-Zähler für „Läufe & Review" (P1/B4).
 * 0 solange lädt/Fehler; 60s-Poll hält den Badge ohne manuelles Invalidieren aktuell.
 */
import { useQuery } from '@tanstack/react-query'

import { getPendingSuggestionCount } from '@/lib/api/channel-content-bulk'

export function usePendingReviewCount(): number {
  const { data } = useQuery({
    queryKey: ['channel-content', 'pending-count'],
    queryFn: getPendingSuggestionCount,
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
  return data?.needs_review ?? 0
}
